import { Helmet } from 'react-helmet-async';
import { Layout } from '@/components/layout/Layout';
import { MembershipApplications } from '@/components/sections/MembershipApplications';
import { MembershipDues } from '@/components/sections/MembershipDues';
import { useMembershipData } from '@/hooks/useMembershipData';
import type { ContactInfo, NavigationItem } from '@/data/types';
import contactData from '@/data/contact.json';
import navigationData from '@/data/navigation.json';

export function Membership() {
  const membershipData = useMembershipData();

  return (
    <>
      <Helmet>
        <title>{membershipData.title} - Wayland Rod & Gun Club</title>
        <meta name="description" content={membershipData.description} />
      </Helmet>

      <Layout
        contactInfo={contactData as ContactInfo}
        navigationItems={navigationData as NavigationItem[]}
      >
        <div className="p-4 sm:p-8 space-y-8 sm:space-y-12 max-w-4xl mx-auto">
          {/* Page Header */}
          <div className="text-center">
            <h1 className="text-4xl sm:text-5xl font-cursive text-primary-700 mb-4">
              {membershipData.title}
            </h1>
            <p className="text-lg text-neutral-600 leading-relaxed max-w-2xl mx-auto">
              {membershipData.description}
            </p>
          </div>

          {/* Applications Section */}
          <MembershipApplications applications={membershipData.applications} />

          {/* Dues Section */}
          <MembershipDues dues={membershipData.dues} />
        </div>
      </Layout>
    </>
  );
}